export const getInitialState = (): any => ({
  uploadProgressData: {}
});